import { useTableContext } from 'lib/context/TableContext/TableContext';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const EmptyDataRows = ({
  title,
  description,
  emptyTextButton,
  buttonComponent,
  isButton = true
}) => {
  const ctx = useTableContext();

  return (
    <>
      <div className="flex w-full flex-col items-center px-20 py-10">
        <Icon icon="illustration-table-no-content" />
        <h1 className="text-base font-500 text-primary-900">{title ?? 'No data available'}</h1>
        <p className="text-sm text-neutral-700">{description}</p>
        {!isButton ? null : buttonComponent ? (
          buttonComponent
        ) : (
          <Button
            className="mt-4"
            textClassName="whitespace-nowrap"
            text={emptyTextButton ?? 'Add new'}
            icon="add-square-mono"
            size="xs"
            variant="link"
            onClick={() => {
              ctx?.setShowModal(true);
            }}
          />
        )}
      </div>
    </>
  );
};

export default EmptyDataRows;
